var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("LayoutBase", [
    _c("div", { staticClass: "c-event-form" }, [
      _c("header", { attrs: { id: "content__header" } }, [
        _c("h1", [_vm._v("Thank you")]),
      ]),
      _vm._v(" "),
      _c("div", [
        _c("p", [
          _vm._v("Successfully registered to " + _vm._s(_vm.event.eventName)),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }